// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn/v1/portal_service.proto (package spwn.spwn.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { SpwnServiceCompletePurchasePAWWith3DSRequest, SpwnServiceCompletePurchasePAWWith3DSResponse, SpwnServiceFetchPawBalanceRequest, SpwnServiceFetchPawBalanceResponse, SpwnServiceFetchPawChargeHistoryRequest, SpwnServiceFetchPawChargeHistoryResponse, SpwnServiceFetchPawUsageHistoryRequest, SpwnServiceFetchPawUsageHistoryResponse, SpwnServicePurchasePawWithCard3DSRequest, SpwnServicePurchasePawWithCard3DSResponse, SpwnServicePurchasePawWithCardRequest, SpwnServicePurchasePawWithCardResponse, SpwnServicePurchasePawWithMember3DSRequest, SpwnServicePurchasePawWithMember3DSResponse, SpwnServicePurchasePawWithMemberRequest, SpwnServicePurchasePawWithMemberResponse, SpwnServiceSecureTran2Request, SpwnServiceSecureTran2Response, SpwnServiceUsePawValueRequest, SpwnServiceUsePawValueResponse } from "./portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.spwn.v1.SpwnService
 */
export const SpwnService = {
    typeName: "spwn.spwn.v1.SpwnService",
    methods: {
        /**
         * PAWの残高を取得する
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.FetchPawBalance
         */
        fetchPawBalance: {
            name: "FetchPawBalance",
            I: SpwnServiceFetchPawBalanceRequest,
            O: SpwnServiceFetchPawBalanceResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * PAWのチャージ履歴を取得する
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.FetchPawChargeHistory
         */
        fetchPawChargeHistory: {
            name: "FetchPawChargeHistory",
            I: SpwnServiceFetchPawChargeHistoryRequest,
            O: SpwnServiceFetchPawChargeHistoryResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * PAWの使用履歴を取得する
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.FetchPawUsageHistory
         */
        fetchPawUsageHistory: {
            name: "FetchPawUsageHistory",
            I: SpwnServiceFetchPawUsageHistoryRequest,
            O: SpwnServiceFetchPawUsageHistoryResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * 新規クレジットカードでPAWをチャージする
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.PurchasePawWithCard
         */
        purchasePawWithCard: {
            name: "PurchasePawWithCard",
            I: SpwnServicePurchasePawWithCardRequest,
            O: SpwnServicePurchasePawWithCardResponse,
            kind: MethodKind.Unary,
        },
        /**
         * 新規クレジットカードでPAWをチャージする（3Dセキュア2.0対応版）
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.PurchasePawWithCard3DS
         */
        purchasePawWithCard3DS: {
            name: "PurchasePawWithCard3DS",
            I: SpwnServicePurchasePawWithCard3DSRequest,
            O: SpwnServicePurchasePawWithCard3DSResponse,
            kind: MethodKind.Unary,
        },
        /**
         * 登録済みクレジットカードでPAWをチャージする
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.PurchasePawWithMember
         */
        purchasePawWithMember: {
            name: "PurchasePawWithMember",
            I: SpwnServicePurchasePawWithMemberRequest,
            O: SpwnServicePurchasePawWithMemberResponse,
            kind: MethodKind.Unary,
        },
        /**
         * 登録済みクレジットカードでPAWをチャージする（3Dセキュア2.0対応版）
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.PurchasePawWithMember3DS
         */
        purchasePawWithMember3DS: {
            name: "PurchasePawWithMember3DS",
            I: SpwnServicePurchasePawWithMember3DSRequest,
            O: SpwnServicePurchasePawWithMember3DSResponse,
            kind: MethodKind.Unary,
        },
        /**
         * PAWを使用する
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.UsePawValue
         */
        usePawValue: {
            name: "UsePawValue",
            I: SpwnServiceUsePawValueRequest,
            O: SpwnServiceUsePawValueResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.spwn.v1.SpwnService.SecureTran2
         */
        secureTran2: {
            name: "SecureTran2",
            I: SpwnServiceSecureTran2Request,
            O: SpwnServiceSecureTran2Response,
            kind: MethodKind.Unary,
        },
        /**
         * PAWの購入を完了する (3Dセキュア2.0対応版)
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.CompletePurchasePAWWith3DS
         */
        completePurchasePAWWith3DS: {
            name: "CompletePurchasePAWWith3DS",
            I: SpwnServiceCompletePurchasePAWWith3DSRequest,
            O: SpwnServiceCompletePurchasePAWWith3DSResponse,
            kind: MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map